export default [
    {
        path: '/user/liste',
        name: 'Liste',
        component: () => import('@/views/users/UserList.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Utilisateurs',
          breadcrumb: [
            {
              text: 'Liste',
              active: true,
            },
          ],
        },
      },
      {
        path: '/user/ajouter/:id?',
        name: 'ajouter-user',
        component: () => import('@/views/users/UserAdd.vue'),
        meta: {
          requiresAuth: true,
          requiresAdminOrSuperAdmin: true,
          pageTitle: 'Utilisateurs',
          breadcrumb: [
            {
              text: 'Ajout',
              active: true,
            },
          ],
        },
      },
      
      {
        path: '/profile/:id?',
        name: 'profile',
        meta: { requiresAuth: true },
        component: () => import('@/views/profil/ProfilView.vue'),
        
      },
]